import React, { useState } from 'react';

import './callback.scss';

interface CallbackProps {

}

const Callback: React.FC<CallbackProps> = (props: CallbackProps) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className="component-callback">
      {loading && (
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      )}
      <iframe
        width="100%"
        height="100%"
        src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ2ZeMe7ekWNTKCbYIcvvIikIGlrKFUUWjXz1aE6tqDTfGnCCRtF7zo2RMvZE_PvDTB9CsUbNj_v?gv=true"
        onLoad={() => setLoading(false)}
        className={`${loading? '' : 'loaded'}`}
      ></iframe>
    </div>
  );
};

export default Callback;